export const retireServerShell = (
    element,
    schedule = requestAnimationFrame,
) => {
    const shell = element
        ?.closest('[data-shipping-tool-shell]')
        ?.querySelector('[data-shipping-tool-server-shell]');

    if (!shell) {
        return;
    }

    schedule(() => {
        schedule(() => {
            shell.style.visibility = 'hidden';
        });
    });
};
